$(document).ready(function (e) {
  $(".mob-mnu-ic, .mobilemenu li a").click(function (e) {
    $(".mobilemenu").slideToggle();
    $(".dl-trigger").toggleClass("dl-active");
  });

  $(".inp-chk").change(function () {
    if ($(this).prop("checked")) {
      $(".withoutthirdzy").hide();
      $(".withthirdzy").fadeIn();
      $(".opt_text1").addClass("active");
      $(".opt_text2").removeClass("active");
      $("ul.compare__list li").removeClass("active");
    } else {
      $(".withthirdzy").hide();
      $(".withoutthirdzy").fadeIn();
      $(".opt_text2").addClass("active");
      $(".opt_text1").removeClass("active");
      $("ul.compare__list li").addClass("active");
    }
  });

  $(".ing-sec").slick({
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 2200,
        settings: {
          centerMode: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
        },
      },
    ],
  });

  //accordion JS
  $(".acdn-heading").click(function () {
    var questionDiv = $(this);
    var answerDiv = $(this).next(".acdn-content");
    var idx = $(".acdn-content").index(answerDiv);

    $(".acdn-content").each(function (index, ansDiv) {
      if (index != idx && $(ansDiv).is(":visible")) {
        $(ansDiv).slideUp(500, function () {
          $(ansDiv).prev(".acdn-heading").removeClass("accordion-open");
        });
      }
    });

    if (answerDiv.is(":visible")) {
      answerDiv.stop().slideUp(500, function () {
        questionDiv.removeClass("accordion-open");
      });
    } else {
      questionDiv.addClass("accordion-open");
      answerDiv.stop().slideDown(500);
    }
  });
});

$(document).scroll(function () {
  if ($(this).scrollTop() > 40) {
    $(".top-fix-bar").addClass("fixed-nav");
  } else {
    $(".top-fix-bar").removeClass("fixed-nav");
  }

  if ($(this).scrollTop() > 10) {
    $(".mobilemenu").addClass("mobimenu-top");
  } else {
    $(".mobilemenu").removeClass("mobimenu-top");
  }
});
